import * as types from "./types";
import { SuppliersService } from "../../services/suppliers.service";
import { JSON_STRING, HttpClient, MHTTPCL } from "../../../../services/http/http-client";
import { getNavTabModule } from "../../../../dt-plugins/sidewindow/nav-tab";
import { EOL_REACHED } from "../../../../dt-plugins/advanced-search/load.model";
import { setMainNavInactive } from "../../../../store/app/mutations";
import router from '../../../../router';

const NavTabModule = getNavTabModule(types.SupplierDetails, 'supplierDetails');
export const distributionSupplierActions = {
  async [types.DistributionSupplierData.FETCH.ALL]({ commit, getters, dispatch }, payload) {

  },
  async [types.SupplierList.FETCH.ALL]({ commit, getters, state }, payload) {
    const { start, row_count, searchMode, basicFilter, searchFilter } = payload;

    let res;

    if (searchMode == 'none') {
      if (start == 0) {

        res = await SuppliersService.getSuppliersList({ start });
        commit(types.SupplierList.SET.ALL, res.data);
      } else {
        res = await SuppliersService.getSuppliersList({ start });
        commit(types.SupplierList.SET.ALL, {
          ...getters.supplierList,
          suppliers: [
            ...getters.supplierList?.suppliers,
            ...res.data.suppliers,
          ]
       });

        // Setting EOL
        if (!(res?.data?.length > 0)) {
          return EOL_REACHED;
        }
      }

    } else if (searchMode == 'basic') {
      const { searchString } = basicFilter;

      res = await SuppliersService.getFilteredSuppliersList(searchString);
      console.log('none', res.data)
      if (start == 0) {
        commit(types.SupplierList.SET.ALL, {
          ...getters.supplierList,
          suppliers: res.data.suppliers
        });
      } else {
        commit(types.SupplierList.SET.ALL, {
          ...getters.supplierList,
          suppliers: [
            ...getters.supplierList.suppliers,
            ...res.data.suppliers
          ]
        });
      }


      // Setting EOL
      if (!(res?.data?.length > 0)) {
        return EOL_REACHED;
      }
    }

  },
  async [types.SupplierList.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { supplier_id } = payload;
    const nextAccountsList = await SuppliersService.removeSupplier(supplier_id);
    commit(types.SupplierList.DELETE.SINGLE, payload);
  },
  async [types.SupplierList.SET.ALL]({ commit, getters }, payload) {
    commit(types.SupplierList.SET.ALL, {
      ...getters.supplierList,
      suppliers: payload
    });
  },
  // Show Sidewindow
  async [types.SupplierDetails.FETCH.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, supplier, reload } = payload;

    flag = typeof flag === "boolean" ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = "supplier_id";
    const itemName = "supplier";
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = "supplierDetails";
    const DetailsAction = types.SupplierDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true
      };
    });

    // HTTP Req
    const detailsData = await HttpClient.mergeRequests([
      SuppliersService.fetchDistributionSupplierDetailsTabSetup(supplier.supplier_id),
      SuppliersService.fetchDistributionSupplierOverviewTabSetup(supplier.supplier_id),
      SuppliersService.fetchDistributionSupplierCatalogueTabSetup(supplier.supplier_id),
      SuppliersService.fetchDistributionSupplierOrderTabSetup(supplier.supplier_id),

      // SuppliersService.fetchDistributionSupplierInvoiceCostTabSetup(supplier.supplier_id),

    ]);
    const detailsData1 = await HttpClient.mergeRequests([

      SuppliersService.fetchDistributionSupplierDetailsTabStockCheck(supplier.supplier_id),
      // SuppliersService.fetchDistributionSupplierInvoiceCostTabSetup(supplier.supplier_id),

    ]);
    const stocKProducts = detailsData1?.products || []
    console.log("detailsData", detailsData);

    // DBox
    NavTabHelper.setSingleNavTabDetails(
      primaryKeyValue,
      (detailsDict, supplier) => {
        return {
          ...supplier,
          ...detailsData,
          stocKProducts,
          loading: false,

        };
      }
    );
  },
  // Left NavItem child details
  ...NavTabModule.implementActions(
    "supplier_id",
    "suppliers/supplier_id/tab",
    "suppliers",
    () => router,
    "distribution",
    (value, key) => {
      const { supplier } = value;
      console.log('value', value);
      return {
        title:
          value && value.supplier && value.supplier.supplier_name
            ? value.supplier.supplier_name
            : key,
        full_title:
          value && value.supplier && value.supplier.supplier_name
            ? value.supplier.supplier_name
            : key
      };
    }
  ),
  // Action of Updating single Object
  async [types.SupplierDetails.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    console.log("update payload ", payload);

    const { name, value, selectedSupplierDetails } = payload;
    const { supplier } = selectedSupplierDetails;
    const { supplier_id } = supplier;
    NavTabHelper.updateSingleNavTabDetails(supplier_id, supplierDetailsObj => {
      console.log('supplierDetailsObj', supplierDetailsObj)
      return {
        supplier: {
          ...supplierDetailsObj.supplier,
          [name]: value
        },


      };
    });

    const table = "l_suppliers";

    const updatedAccountsDetailsRes = await MHTTPCL.modifyJSON(
      undefined,
      supplier_id,
      name,
      value,
      table
    );
  },
  async [types.SupplierRelatedContacts.SET.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("payload", payload)

    const { external_id, contact_relations } = payload;

    NavTabHelper.updateSingleNavTabDetails(external_id, (_, supplierDetailsObj) => {
      return {
        ...supplierDetailsObj,
        contact_relations: contact_relations
      };
    })
  },
  async [types.SupplierRelatedContacts.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log('payload', payload)
    const { contact, selectedSupplierDetails } = payload;
    const { supplier } = selectedSupplierDetails;
    const { supplier_id } = supplier;
    const { contact_relation_id } = contact;

    NavTabHelper.updateSingleNavTabDetails(supplier_id, supplierDetailsObj => {
      console.log('supplierDetailsObj', supplierDetailsObj)
      return {

        contact_relations: supplierDetailsObj.contact_relations.
          filter(e => e.contact_relation_id != contact_relation_id)
      }
    });

    const deletedContact = await SuppliersService.deleteContactRelation(contact_relation_id)


  },

  async [types.SupplierRelatedContacts.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("types.ReleaseDetails.UPDATE.SINGLE", payload)


    const { name, value, item, selectedSupplierDetails } = payload;
    const { supplier } = selectedSupplierDetails
    const { supplier_id } = supplier;

    const key = 'contact_relation_id';
    const kVal = item[key];
    const table = 'contact_relations';

    // const oldValue = item[name];
    // if (oldValue == value) {
    //   return;
    // }


    NavTabHelper.updateSingleNavTabDetails(supplier_id, (supplierDetailsObj) => {
      return {
        contact_relations: supplierDetailsObj.contact_relations.map(e => {
          if (e.contact_relation_id == item.contact_relation_id) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    })

    const modifiedRelease = await MHTTPCL.modifyJSON(key, kVal, name, value, table)

  },
  async [types.DistributionSupplierOrderList.SET.ALL]({ commit, getters, dispatch }, {
    orders,
    supplier_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(supplier_id, (_, selectedSupplierDetails) => {
      return {
        ...selectedSupplierDetails,
        orders: orders
      };
    })
  },
  async [types.DistributionSupplierCatalogue.SET.ALL]({ commit, getters, dispatch }, {
    products,
    supplier_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(supplier_id, (_, selectedSupplierDetails) => {
      return {
        ...selectedSupplierDetails,
        products: products
      };
    })
  },
  async [types.DistributionSupplierStockCheck.SET.ALL]({ commit, getters, dispatch }, {
    stocKProducts,
    supplier_id
  }) {
    console.log('actions',stocKProducts)
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(supplier_id, (_, selectedSupplierDetails) => {
      return {
        ...selectedSupplierDetails,
        stocKProducts: stocKProducts
      };
    })
  },
  async [types.DistributionSupplierInvoiceContact.SET.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("payload", payload)

    const { external_id, item_contact } = payload;

    NavTabHelper.updateSingleNavTabDetails(external_id, (_, selectedSupplierDetails) => {
      return {
        ...selectedSupplierDetails,
        invoice_contact: item_contact
      };
    })
  },

  async [types.DistributionSupplierDeliveryAddress.SET.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("payload", payload)

    const { external_id, item_contact } = payload;

    NavTabHelper.updateSingleNavTabDetails(external_id, (_, selectedSupplierDetails) => {
      return {
        ...selectedSupplierDetails,
        delivery_contact: item_contact
      };
    })
  },


  async [types.SET_DISTRIBUTION_SUPPLIER_FILES]({ dispatch, getters }, { files, externalId, externalTable }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const supplier_id = externalId;
    NavTabHelper.setSingleNavTabDetails(supplier_id, (_, supplierDetailsObj) => {
      return {
        ...supplierDetailsObj,
        files: files,
      }
    });
  },

};
